// extracted by mini-css-extract-plugin
export default {"newsLink":"ButtonWhite_newsLink__cFCNz"};